import React from "react";

import { localizer } from "../../../Translator";

import { Grid } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';

export class AddressFormatsModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <React.Fragment>
        <Dialog
          open={this.props.openModal}
          onClose={this.props.handleCloseModal}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          fullWidth
          maxWidth={"sm"}
        >
          <DialogTitle id="alert-dialog-title" className="bg-primary-color">
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.props.handleCloseModal}></i>
            <Typography className="typography-generic dialog-title">{localizer.AddressFormats}</Typography>
          </DialogTitle>

          <DialogContent>
            <Grid container item md={12}>
              <Typography className="typography-generic">{localizer.AddressFormatsIntroduction}</Typography>
            </Grid>
            <Grid container direction="row" className="mt-10">
              {/* Line 1 */}
              <Grid container item md={2}> 
                <Typography className="typography-generic font-weight-bold">{localizer.AddressFormatsLine1}</Typography>
              </Grid>
              <Grid container item md={10} style={{borderBottom: "solid 1px"}}>
                <Typography className="typography-generic">{localizer.AddressFormatsLine1Description}</Typography>
              </Grid>
              {/* Line 2 */}
              <Grid container item md={2}> 
                <Typography className="typography-generic font-weight-bold">{localizer.AddressFormatsLine2}</Typography>
              </Grid>
              <Grid container item md={10} style={{borderBottom: "solid 1px"}}>
                <Typography className="typography-generic">{localizer.AddressFormatsLine2Description}</Typography>
              </Grid>
              {/* Line 3 */}
              <Grid container item md={2}> 
                <Typography className="typography-generic font-weight-bold">{localizer.AddressFormatsLine3}</Typography>
              </Grid>
              <Grid container item md={10} style={{borderBottom: "solid 1px"}}>
                <Typography className="typography-generic">{localizer.AddressFormatsLine3Description}</Typography>
              </Grid>
              {/* Line 4 */}
              <Grid container item md={2}> 
                <Typography className="typography-generic font-weight-bold">{localizer.AddressFormatsLine4}</Typography>
              </Grid>
              <Grid container item md={10} style={{borderBottom: "solid 1px"}}>
                <Typography className="typography-generic">{localizer.AddressFormatsLine4Description}</Typography>
              </Grid>
            </Grid>

            <Grid container item md={12} className="mt-20">
              <ul>
                <li className="typography-generic">{localizer.AddressFormatsLine1Explanation}</li>
                <li className="typography-generic">{localizer.AddressFormatsLine2Explanation}</li>
                <li className="typography-generic">{localizer.AddressFormatsLine3Explanation}</li>
                <li className="typography-generic">{localizer.AddressFormatsLine4Explanation}</li>
              </ul>
            </Grid>
            
          </DialogContent>
        </Dialog>
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/common/ocr/AddressFormatsModal.js